module.exports = __webpack_public_path__ + "img/sample-logo.980fe52d.png";